import { Request,BaseApiUrl } from "./api";
// 工程模块
// 列表
export const getProjectListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Project/get`, { params: params });
};
//编辑
export const editProject = (params) => {
  return Request.post(`${BaseApiUrl}/api/Project/put`, params);
};
//新增
export const addProject = (params) => {
  return Request.post(`${BaseApiUrl}/api/Project/post`, params);
};
//批量删除
export const batchDeleteProject = (params) => {
  return Request.post(`${BaseApiUrl}/api/Project/BatchDelete`, params);
};
// export const batchDeleteProject = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/Project/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };